// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#CRMInformation_component {
  overflow: scroll;
  background-color: #f4f4f4;
  width: 30%;
  padding: 0 20px;
  padding-top: 15px;
  position: fixed;
  right: 0;
  height: 100%;
  overflow: auto;
  padding-bottom: 100px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
#CRMInformation_component .general_information {
  text-transform: uppercase;
  text-align: left !important;
  background-color: #727272;
  color: white;
  border-radius: 10px;
  font-size: 18px;
  display: block;
  margin-bottom: 10px;
}
#CRMInformation_component .customer-details-card {
  background-color: white;
  margin-bottom: 10px;
  border-radius: 15px;
  padding-bottom: 10px;
}
#CRMInformation_component .customer-details-card h2 {
  text-transform: uppercase;
  text-align: left !important;
  background-color: #727272;
  color: white;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  padding: 5px 15px;
  font-size: 18px;
}
#CRMInformation_component .customer-details-card .border-right {
  border-right: 1px solid #ddd;
}
#CRMInformation_component .customer-details-card .border-right:last-child {
  border-right: none;
}
#CRMInformation_component .customer-details-container {
  font-size: 13px;
  color: black;
  text-transform: none;
}
#CRMInformation_component .workflow-activities {
  padding-bottom: 300px !important;
}
#CRMInformation_component .quality-check-box {
  margin: 20px 0;
}
#CRMInformation_component .modifiedDesign {
  color: red;
}
#CRMInformation_component img {
  width: 100px;
}
@media all and (min-width: 0px) and (max-width: 600px) {
  #CRMInformation_component {
    display: none;
    height: 30%;
    top: 70%;
    width: 100%;
  }
}
#CRMInformation_component h2 {
  text-align: center;
  padding: 6px 2px;
}
#CRMInformation_component .accordion-item .btn-novita-pink-outline {
  padding: 3px 6px;
}
#CRMInformation_component .accordion-item .accordion-header {
  text-align: center;
  padding: 0px 0px;
  background-color: transparent;
}
#CRMInformation_component .accordion-item .accordion-header .accordion-button {
  background-color: white;
  color: black;
  text-align: left;
  width: 100%;
  padding: 5px 15px;
  display: block;
  border-bottom: 1px solid #dbb7bb;
}
#CRMInformation_component .accordion-item .accordion-header .accordion-button:focus {
  outline: none;
  box-shadow: none;
}
#CRMInformation_component .accordion-item .accordion-header .accordion-button.collapsed {
  border-bottom: 1px solid transparent;
}
#CRMInformation_component .accordion-item .accordion-header .accordion-button::after {
  display: inline-block;
  float: right;
}
#CRMInformation_component .choose_message {
  margin-top: 50px;
  text-align: center;
  font-size: 30px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
#CRMInformation_component .choose_message span {
  font-size: 40px;
}
#CRMInformation_component .link_to_detail a {
  background-color: transparent;
  display: inline-block;
  color: #9a9696;
  border: none;
  text-align: center;
  font-size: 13px;
  line-height: 8px;
  padding: 0px 10px;
  text-decoration: none;
}
#CRMInformation_component .link_to_detail a img {
  width: 40px;
}
#CRMInformation_component .details {
  padding: 6px 6px;
}

#CRMInformation_component_merge_customer {
  background-color: #f4f4f4;
}
#CRMInformation_component_merge_customer .general_information {
  text-transform: uppercase;
  text-align: left !important;
  background-color: #727272;
  color: white;
  border-radius: 10px;
  font-size: 18px;
  display: block;
  margin-bottom: 10px;
}
#CRMInformation_component_merge_customer .customer-details-card {
  background-color: white;
  margin-bottom: 10px;
  border-radius: 15px;
  padding-bottom: 10px;
}
#CRMInformation_component_merge_customer .customer-details-card h2 {
  text-transform: uppercase;
  text-align: left !important;
  background-color: #727272;
  color: white;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  padding: 5px 15px;
  font-size: 18px;
}
#CRMInformation_component_merge_customer .customer-details-card .border-right {
  border-right: 1px solid #ddd;
}
#CRMInformation_component_merge_customer .customer-details-card .border-right:last-child {
  border-right: none;
}
#CRMInformation_component_merge_customer .customer-details-container {
  font-size: 13px;
  color: black;
  text-transform: none;
}
#CRMInformation_component_merge_customer .workflow-activities {
  padding-bottom: 300px !important;
}
#CRMInformation_component_merge_customer .quality-check-box {
  margin: 20px 0;
}
#CRMInformation_component_merge_customer .modifiedDesign {
  color: red;
}
#CRMInformation_component_merge_customer img {
  width: 100px;
}
@media all and (min-width: 0px) and (max-width: 600px) {
  #CRMInformation_component_merge_customer {
    display: none;
    height: 30%;
    top: 70%;
    width: 100%;
  }
}
#CRMInformation_component_merge_customer h2 {
  text-align: center;
  padding: 6px 2px;
}
#CRMInformation_component_merge_customer .accordion-item .btn-novita-pink-outline {
  padding: 3px 6px;
}
#CRMInformation_component_merge_customer .accordion-item .accordion-header {
  text-align: center;
  padding: 0px 0px;
  background-color: transparent;
}
#CRMInformation_component_merge_customer .accordion-item .accordion-header .accordion-button {
  background-color: white;
  color: black;
  text-align: left;
  width: 100%;
  padding: 5px 15px;
  display: block;
  border-bottom: 1px solid #dbb7bb;
}
#CRMInformation_component_merge_customer .accordion-item .accordion-header .accordion-button:focus {
  outline: none;
  box-shadow: none;
}
#CRMInformation_component_merge_customer .accordion-item .accordion-header .accordion-button.collapsed {
  border-bottom: 1px solid transparent;
}
#CRMInformation_component_merge_customer .accordion-item .accordion-header .accordion-button::after {
  display: inline-block;
  float: right;
}
#CRMInformation_component_merge_customer .choose_message {
  margin-top: 50px;
  text-align: center;
  font-size: 30px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
#CRMInformation_component_merge_customer .choose_message span {
  font-size: 40px;
}
#CRMInformation_component_merge_customer .link_to_detail a {
  background-color: transparent;
  display: inline-block;
  color: #9a9696;
  border: none;
  text-align: center;
  font-size: 13px;
  line-height: 8px;
  padding: 0px 10px;
  text-decoration: none;
}
#CRMInformation_component_merge_customer .link_to_detail a img {
  width: 40px;
}
#CRMInformation_component_merge_customer .details {
  padding: 6px 6px;
}
#CRMInformation_component_merge_customer .submit-btn {
  background-color: black;
  display: inline-block;
  color: #fff;
  text-align: center;
  font-size: 14px;
  line-height: 14px;
  padding: 5px 25px;
  text-transform: uppercase;
  border-radius: 6px;
  font-weight: 400;
  border-color: black;
}

#sales_list_information tr {
  cursor: pointer;
}
#sales_list_information tr.highlighted_row {
  background-color: #e3b5bb;
  color: #fff;
}
#sales_list_information tr.highlighted_row td {
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/css/crm/customer_information.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EAkDA,yBAAA;EAIA,UAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,QAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;EACA,4BAAA;EACA,+BAAA;AAnDF;AAXE;EACE,yBAAA;EACA,2BAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAaJ;AAVE;EACE,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;AAYJ;AAXI;EACE,yBAAA;EACA,2BAAA;EACA,yBAAA;EACA,YAAA;EACA,4BAAA;EACA,6BAAA;EACA,iBAAA;EACA,eAAA;AAaN;AAXI;EACE,4BAAA;AAaN;AAZM;EACE,kBAAA;AAcR;AATE;EACE,eAAA;EACA,YAAA;EACA,oBAAA;AAWJ;AARE;EACE,gCAAA;AAUJ;AARE;EACE,cAAA;AAUJ;AARE;EACE,UAAA;AAUJ;AAPE;EACE,YAAA;AASJ;AAGE;EAjEF;IAkEI,aAAA;IACA,WAAA;IACA,QAAA;IACA,WAAA;EAAF;AACF;AACE;EACE,kBAAA;EACA,gBAAA;AACJ;AAEI;EACE,gBAAA;AAAN;AAEI;EACE,kBAAA;EACA,gBAAA;EACA,6BAAA;AAAN;AACM;EACE,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,gCAAA;AACR;AAAQ;EACE,aAAA;EACA,gBAAA;AAEV;AAAQ;EACE,oCAAA;AAEV;AAAQ;EACE,qBAAA;EACA,YAAA;AAEV;AAGE;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AADJ;AAEI;EACE,eAAA;AAAN;AAMI;EACE,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AAJN;AAKM;EACE,WAAA;AAHR;AAOE;EACE,gBAAA;AALJ;;AASA;EAkDE,yBAAA;AAvDF;AAME;EACE,yBAAA;EACA,2BAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAJJ;AAOE;EACE,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;AALJ;AAMI;EACE,yBAAA;EACA,2BAAA;EACA,yBAAA;EACA,YAAA;EACA,4BAAA;EACA,6BAAA;EACA,iBAAA;EACA,eAAA;AAJN;AAMI;EACE,4BAAA;AAJN;AAKM;EACE,kBAAA;AAHR;AAQE;EACE,eAAA;EACA,YAAA;EACA,oBAAA;AANJ;AASE;EACE,gCAAA;AAPJ;AASE;EACE,cAAA;AAPJ;AASE;EACE,UAAA;AAPJ;AAUE;EACE,YAAA;AARJ;AAUE;EAtDF;IAuDI,aAAA;IACA,WAAA;IACA,QAAA;IACA,WAAA;EAPF;AACF;AAQE;EACE,kBAAA;EACA,gBAAA;AANJ;AASI;EACE,gBAAA;AAPN;AASI;EACE,kBAAA;EACA,gBAAA;EACA,6BAAA;AAPN;AAQM;EACE,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,gCAAA;AANR;AAOQ;EACE,aAAA;EACA,gBAAA;AALV;AAOQ;EACE,oCAAA;AALV;AAOQ;EACE,qBAAA;EACA,YAAA;AALV;AAUE;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AARJ;AASI;EACE,eAAA;AAPN;AAaI;EACE,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AAXN;AAYM;EACE,WAAA;AAVR;AAcE;EACE,gBAAA;AAZJ;AAeE;EACE,uBAAA;EACA,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAbJ;;AAkBE;EACE,eAAA;AAfJ;AAiBI;EACE,yBAAA;EACA,WAAA;AAfN;AAiBM;EACE,WAAA;AAfR","sourcesContent":["#CRMInformation_component {\n  overflow: scroll;\n  .general_information {\n    text-transform: uppercase;\n    text-align: left !important;\n    background-color: #727272;\n    color: white;\n    border-radius: 10px;\n    font-size: 18px;\n    display: block;\n    margin-bottom: 10px;\n  }\n\n  .customer-details-card {\n    background-color: white;\n    margin-bottom: 10px;\n    border-radius: 15px;\n    padding-bottom: 10px;\n    h2 {\n      text-transform: uppercase;\n      text-align: left !important;\n      background-color: #727272;\n      color: white;\n      border-top-left-radius: 15px;\n      border-top-right-radius: 15px;\n      padding: 5px 15px;\n      font-size: 18px;\n    }\n    .border-right {\n      border-right: 1px solid #ddd;\n      &:last-child {\n        border-right: none;\n      }\n    }\n  }\n\n  .customer-details-container {\n    font-size: 13px;\n    color: black;\n    text-transform: none;\n  }\n\n  .workflow-activities {\n    padding-bottom: 300px !important;\n  }\n  .quality-check-box {\n    margin: 20px 0;\n  }\n  .modifiedDesign {\n    color: red;\n  }\n  background-color: #f4f4f4;\n  img {\n    width: 100px;\n  }\n  width: 30%;\n  padding: 0 20px;\n  padding-top: 15px;\n  position: fixed;\n  right: 0;\n  height: 100%;\n  overflow: auto;\n  padding-bottom: 100px;\n  border-top-left-radius: 15px;\n  border-bottom-left-radius: 15px;\n  @media all and (min-width: 0px) and (max-width: 600px) {\n    display: none;\n    height: 30%;\n    top: 70%;\n    width: 100%;\n  }\n  h2 {\n    text-align: center;\n    padding: 6px 2px;\n  }\n  .accordion-item {\n    .btn-novita-pink-outline {\n      padding: 3px 6px;\n    }\n    .accordion-header {\n      text-align: center;\n      padding: 0px 0px;\n      background-color: transparent;\n      .accordion-button {\n        background-color: white;\n        color: black;\n        text-align: left;\n        width: 100%;\n        padding: 5px 15px;\n        display: block;\n        border-bottom: 1px solid #dbb7bb;\n        &:focus {\n          outline: none;\n          box-shadow: none;\n        }\n        &.collapsed {\n          border-bottom: 1px solid transparent;\n        }\n        &::after {\n          display: inline-block;\n          float: right;\n        }\n      }\n    }\n  }\n  .choose_message {\n    margin-top: 50px;\n    text-align: center;\n    font-size: 30px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    span {\n      font-size: 40px;\n    }\n  }\n  .link_to_detail {\n    // float: right;\n    //margin-right: 5px;\n    a {\n      background-color: transparent;\n      display: inline-block;\n      color: #9a9696;\n      border: none;\n      text-align: center;\n      font-size: 13px;\n      line-height: 8px;\n      padding: 0px 10px;\n      text-decoration: none;\n      img {\n        width: 40px;\n      }\n    }\n  }\n  .details {\n    padding: 6px 6px;\n  }\n}\n\n#CRMInformation_component_merge_customer {\n  .general_information {\n    text-transform: uppercase;\n    text-align: left !important;\n    background-color: #727272;\n    color: white;\n    border-radius: 10px;\n    font-size: 18px;\n    display: block;\n    margin-bottom: 10px;\n  }\n\n  .customer-details-card {\n    background-color: white;\n    margin-bottom: 10px;\n    border-radius: 15px;\n    padding-bottom: 10px;\n    h2 {\n      text-transform: uppercase;\n      text-align: left !important;\n      background-color: #727272;\n      color: white;\n      border-top-left-radius: 15px;\n      border-top-right-radius: 15px;\n      padding: 5px 15px;\n      font-size: 18px;\n    }\n    .border-right {\n      border-right: 1px solid #ddd;\n      &:last-child {\n        border-right: none;\n      }\n    }\n  }\n\n  .customer-details-container {\n    font-size: 13px;\n    color: black;\n    text-transform: none;\n  }\n\n  .workflow-activities {\n    padding-bottom: 300px !important;\n  }\n  .quality-check-box {\n    margin: 20px 0;\n  }\n  .modifiedDesign {\n    color: red;\n  }\n  background-color: #f4f4f4;\n  img {\n    width: 100px;\n  }\n  @media all and (min-width: 0px) and (max-width: 600px) {\n    display: none;\n    height: 30%;\n    top: 70%;\n    width: 100%;\n  }\n  h2 {\n    text-align: center;\n    padding: 6px 2px;\n  }\n  .accordion-item {\n    .btn-novita-pink-outline {\n      padding: 3px 6px;\n    }\n    .accordion-header {\n      text-align: center;\n      padding: 0px 0px;\n      background-color: transparent;\n      .accordion-button {\n        background-color: white;\n        color: black;\n        text-align: left;\n        width: 100%;\n        padding: 5px 15px;\n        display: block;\n        border-bottom: 1px solid #dbb7bb;\n        &:focus {\n          outline: none;\n          box-shadow: none;\n        }\n        &.collapsed {\n          border-bottom: 1px solid transparent;\n        }\n        &::after {\n          display: inline-block;\n          float: right;\n        }\n      }\n    }\n  }\n  .choose_message {\n    margin-top: 50px;\n    text-align: center;\n    font-size: 30px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    span {\n      font-size: 40px;\n    }\n  }\n  .link_to_detail {\n    // float: right;\n    //margin-right: 5px;\n    a {\n      background-color: transparent;\n      display: inline-block;\n      color: #9a9696;\n      border: none;\n      text-align: center;\n      font-size: 13px;\n      line-height: 8px;\n      padding: 0px 10px;\n      text-decoration: none;\n      img {\n        width: 40px;\n      }\n    }\n  }\n  .details {\n    padding: 6px 6px;\n  }\n\n  .submit-btn {\n    background-color: black;\n    display: inline-block;\n    color: #fff;\n    text-align: center;\n    font-size: 14px;\n    line-height: 14px;\n    padding: 5px 25px;\n    text-transform: uppercase;\n    border-radius: 6px;\n    font-weight: 400;\n    border-color: black;\n  }\n}\n\n#sales_list_information {\n  tr {\n    cursor: pointer;\n\n    &.highlighted_row {\n      background-color: #e3b5bb;\n      color: #fff;\n\n      td {\n        color: #fff;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
